export function Item5() {
  return (
    <>
      <p className="text-lg font-medium text-blue-200 mt-6">
        A Simya Capital oferece assessoria completa em transações tributárias
        para empresas que buscam regularizar seus débitos com o Fisco e reduzir
        seus custos de forma segura e eficaz.
      </p>

      <p className="text-lg font-medium text-blue-200 mt-4">
        Nossos serviços incluem a análise de viabilidade, preparação da
        documentação, negociação com o Fisco, celebração do acordo e orientação
        com relação à forma de pagamento da dívida.
      </p>

      <p className="text-lg font-medium text-blue-200 mt-4">
        Contamos com uma equipe de especialistas em tributos com vasta
        experiência e oferecemos um atendimento personalizado e focado nas
        necessidades específicas da sua empresa.
      </p>

      <p className="text-lg font-medium text-blue-200 mt-4">
        Também podemos utilizar nossa rede escritórios de advocacia parceiros
        para a defesa de teses e questionamento de passivos.
      </p>
    </>
  );
}
